// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__22Gri","cell":"ColumnAccessor_cell__3Jwi8","firstCellAccent":"ColumnAccessor_firstCellAccent__322_X"};